import React from "react";
import HoverImage from "react-hover-image";
import xmarkAC from "../../images/catalogues/_xmarkAC.svg";
import xmarkBC from "../../images/catalogues/_xmarkBC.svg";
import styles from "./Products.module.css";

const Truncate = (str) => {
  return str.length > 35 ? str.substring(0, 32) + "..." : str;
};

const ProductCard = ({
  product,
  selectedproducts,
  setSelectedproducts,
  setSingleProduct,
  setOpen,
}) => {
  const handleProductClick = () => {
    setSingleProduct(product);
    setOpen(true);
  };

  const handleAddToCart = () => {
    const isAlreadySelected = selectedproducts.some(
      (item) => item.sortId === product.sortId
    );

    if (isAlreadySelected) {
      return;
    }

    setSelectedproducts([
      {
        color: product.variant[0].colorName,
        choice: product.variant[0].varName,
        index: 0,
        quantity: 1,
        customnumber: product.cust_flag ? 1 : 0,
        ...product,
      },
      ...selectedproducts,
    ]);
  };

  const calculatePrice = () => {
    const baseCost = product.price[0].cost;
    const marginPercent = product.price[0].margin;
    return Math.round(baseCost + (marginPercent / 100) * baseCost);
  };

  const isProductSelected = selectedproducts.some(
    (item) => item.sortId === product.sortId
  );

  return (
    <div className={styles.pCards}>
      {product.image[1] ? (
        <HoverImage
          src={product.image[0]}
          hoverSrc={product.image[1]}
          className={styles.pimage}
          onClick={handleProductClick}
        />
      ) : (
        <img
          src={product.image[0]}
          alt="Image"
          className={styles.pimage}
          onClick={handleProductClick}
        />
      )}
      <div className={styles.pbranding}>
        <p>{product.brandName}</p>
      </div>
      <div className={styles.pCardsbody}>
        <div className={styles.l} onClick={handleProductClick}>
          <h5 className={styles.name}>{Truncate(product.name)}</h5>
          <p className={styles.price}>₹ {calculatePrice()}</p>
        </div>
        <div className={styles.add}>
          <img
            src={isProductSelected ? xmarkAC : xmarkBC}
            alt=""
            className={styles.addimg}
            style={{ cursor: "pointer" }}
            onClick={handleAddToCart}
          />
        </div>
      </div>
    </div>
  );
};

export default ProductCard;
